import React from 'react';

import SpinnerButton from 'src/components/SpinnerButton';
import TooltipWrapper from 'src/components/TooltipWrapper';

interface Props {
    disabled: boolean;
    spinning: boolean;
    text: string;
    tip?: string;
    saveAsNewVersion: () => void;
}

const SaveNewVersion: React.FC<Props> = ({ text, spinning, saveAsNewVersion, disabled, tip = '' }) => {
    return (
        <div className='tools-save'>
            <TooltipWrapper direction='top' contents={tip}>
                <SpinnerButton
                    testid='editor-footer-save-new-version'
                    onClick={saveAsNewVersion}
                    text={text}
                    disabled={disabled || !!tip}
                    spinning={spinning}
                />
            </TooltipWrapper>
        </div>
    );
};

export default React.memo(SaveNewVersion);
